/**
 * Scroll to the beginning of honorees' list
 */
export const scrollTo = (targetSelector) => {
  const targetElement = document.querySelector(targetSelector);
  const targetPositionY = (targetElement && targetElement.offsetTop) || 0;

  window.scrollTo(0, targetPositionY);
};
